module.exports = __webpack_public_path__ + "img/722.123c195f.png";